import { Injectable, PLATFORM_ID, Inject } from '@angular/core';
import { HttpClient, HttpResponse, HttpHeaders } from '@angular/common/http';
import { TransferState, makeStateKey } from '@angular/core';
// rxjs
import { Store } from '@ngrx/store';
import { Subject, Subscription, forkJoin } from 'rxjs';
import { take, retry } from 'rxjs/operators';
// models
import { AppState } from '../../booking/models/app-state.interface';
import { CopyDataInitState } from '../models/copy.interface';
// path globals
import {
  API_PATH,
  ABC_PARTNERS,
  STRAPY_BOOKING_TRANSLATION,
  MOBILE_API_KEY,
} from "../globals";
import { ActivatedRoute } from '@angular/router';
// server state key
const COPY_KEY = makeStateKey('copy');

let copyResponseData: any = null;

@Injectable({
  providedIn: 'root',
})
export class CopyService {
  private _strapiSubscription: Subscription;
  private _copyStoreData: CopyDataInitState = null;

  public copyData$: Subject<any> = new Subject();

  constructor(
    private _appStore: Store<AppState>,
    private _activatedRoute: ActivatedRoute,
    private _http: HttpClient,
    @Inject(PLATFORM_ID) private platformId: Object,
    private _serverState: TransferState,
  ) { }

  getCopy(airline: string = 'OTHER') {
    // STRAPI local
    this.getStaticCopy(airline);
    return;

    this.getStrapiCopy(airline);
  }

  getStaticCopy(airline: string = 'OTHER') {
    this._copyStoreData = this._serverState.get(COPY_KEY, null as any);
    const serverCopy: any = this._copyStoreData;

    if (this._copyStoreData === null || (airline && !serverCopy?.airlines?.find(c => c.carrier.toUpperCase() === airline.toUpperCase()))) {

      this._appStore.dispatch({ type: 'COPY_LOADED', payload: false });
      if (airline && airline.toUpperCase() !== 'OTHER') {
        this._appStore.dispatch({ type: 'COPY_LOADED', payload: false });
        const generic$ = this._http.get('/static-api-data/copy-generic.json');
        const carrier$ = this._http.get(`/static-api-data/copy-generic_${airline}.json`);

        forkJoin([generic$, carrier$])
          .pipe(retry(2))
          .subscribe(
            ([generic, carrier]: [any, any]) => {
              let airlines = [generic];
              if (carrier) {
                airlines = [generic, carrier];
              }
              if (!this._copyStoreData) {
                this._copyStoreData = {};
              }
              this._copyStoreData.airlines = airlines;
              this._copyStoreData.copyLoaded = true;
              copyResponseData = this._copyStoreData;
              this._appStore.dispatch({ type: 'COPY_LOADED', payload: true });
              this._serverState.set(COPY_KEY, this._copyStoreData as any);
            },
            (err) => {
              console.log('copy load from json failed');
              // this.getCopy({});
            }
          );
      } else {
        this._appStore.dispatch({ type: 'COPY_LOADED', payload: false });
        const generic$ = this._http.get("/static-api-data/copy-generic.json");
        generic$.pipe(retry(2)).subscribe(
          (generic: any) => {
            if (!this._copyStoreData) {
              this._copyStoreData = {};
            }

            this._copyStoreData.airlines = [generic];
            this._copyStoreData.copyLoaded = true;
            copyResponseData = this._copyStoreData;
            this._appStore.dispatch({ type: 'COPY_LOADED', payload: true });
            this._serverState.set(COPY_KEY, this._copyStoreData as any);
          },
          (err) => {
            // this.getCopy({});
          }
        );
      }
    } else {
      copyResponseData = this._copyStoreData;
      this._appStore.dispatch({ type: 'COPY_LOADED', payload: true });
    }

  }

  getStrapiCopy(airline: string = 'OTHER') {
    this._copyStoreData = this._serverState.get(COPY_KEY, null as any);
    const serverCopy: any = this._copyStoreData;

    if (this._copyStoreData === null || (airline && !serverCopy?.airlines?.find(c => c.carrier.toUpperCase() === airline.toUpperCase()))) {
      this._appStore.dispatch({ type: 'COPY_LOADED', payload: false });
      let query = 'filter=filters[carrier][$in][0]=OTHER';
      if (airline !== 'OTHER') {
        query += '%26filters[carrier][$in][1]=' + airline;
      }
      console.log('query:', STRAPY_BOOKING_TRANSLATION + query);

      if (this._strapiSubscription) { this._strapiSubscription?.unsubscribe(); }
      this._strapiSubscription = this._http.get(API_PATH + STRAPY_BOOKING_TRANSLATION + query, {
        headers: {
          'Ocp-Apim-Subscription-Key': MOBILE_API_KEY
        }
      })
        .pipe(retry(2))
        .subscribe(
          (res: any) => {
            let airlines = [...res];
            if (!this._copyStoreData) {
              this._copyStoreData = {};
            }
            this._copyStoreData.airlines = airlines;
            this._copyStoreData.copyLoaded = true;
            copyResponseData = this._copyStoreData;
            this._appStore.dispatch({ type: 'COPY_LOADED', payload: true });
            this._serverState.set(COPY_KEY, this._copyStoreData as any);

          },
          err => {
            //  load local files
            this.getStaticCopy();
          });

    } else {
      copyResponseData = this._copyStoreData;
      this._appStore.dispatch({ type: 'COPY_LOADED', payload: true });
    }

  }

  // used
  getCopyBySection(carrier: string, page: string, tags: Array<string>) {
    let copyData: Array<Object> = [];
    console.log(carrier, page, tags);
    if (typeof page === 'undefined' || typeof carrier === 'undefined') {
      return;
    }

    const otherCopyData = this.extractCopyFromData('OTHER', page, tags);
    let airlineCopyData: Array<any> = [];

    if (ABC_PARTNERS.find(partner => partner.code === carrier.toLocaleUpperCase())) {
      airlineCopyData = this.extractCopyFromData(carrier, page, tags);
    }

    const sectionKey = (section: any) => {
      if (Array.isArray(section.tags) && section.tags.length > 0) {
        return section.tags
          .map((tag: string) => tag.toLocaleUpperCase())
          .sort()
          .join('|');
      }
      if (typeof section.title === 'string') {
        return section.title.trim();
      }
      return JSON.stringify(section);
    };

    const sectionMap: { [key: string]: any } = {};

    otherCopyData.forEach((section: any) => {
      sectionMap[sectionKey(section)] = { ...section };
    });

    airlineCopyData.forEach((section: any) => {
      const key = sectionKey(section);
      if (sectionMap[key]) {
        sectionMap[key] = { ...sectionMap[key], ...section };
      } else {
        sectionMap[key] = { ...section };
      }
    });

    copyData = Object.values(sectionMap);

    if (copyData.length > 0) {
      copyData.sort((a: any, b: any) => (b.matches || 0) - (a.matches || 0));
    }

    if (copyData.length === 0) { copyData.push({}); }

    return copyData;

  }

  // used
  extractCopyFromData(c: string, p: string, t: Array<string>) {
    console.log(c, p, t);

    const airlineCopy: any = copyResponseData?.airlines ? copyResponseData.airlines : copyResponseData;
    if (!Array.isArray(airlineCopy)) {
      return [];
    }

    const carrier = airlineCopy.find((i: any) => i.carrier?.toLocaleUpperCase() === c.toLocaleUpperCase())
      || airlineCopy.find((i: any) => i.carrier?.toLocaleUpperCase() === 'OTHER');

    if (!carrier || !Array.isArray(carrier.pages)) {
      return [];
    }

    const pageData = carrier.pages.find((page: any) => page?.page?.toLocaleUpperCase() === p.toLocaleUpperCase());
    if (!pageData || !Array.isArray(pageData.sections)) {
      return [];
    }

    const desiredTags = Array.isArray(t)
      ? t.map((tag: string) => tag.toLocaleUpperCase())
      : [];

    const returnedData = pageData.sections.reduce((acc: any[], section: any) => {
      const sectionTags = Array.isArray(section.tags) ? section.tags : [];
      let matchCount = 0;

      sectionTags.forEach((tag: string) => {
        if (desiredTags.includes(tag.toLocaleUpperCase())) {
          matchCount++;
        }
      });

      if (matchCount > 0) {
        acc.push({ ...section, matches: matchCount });
      }
      return acc;
    }, []);

    returnedData.sort((a: any, b: any) => (b.matches || 0) - (a.matches || 0));
    return returnedData;

  }

  // not used
  getCopyByCarrier(carrier: string) {

    let copyData: any = null;

    if (ABC_PARTNERS.find(partner => partner.code === carrier.toLocaleUpperCase())) {
      const storeData = copyResponseData;
      const copyIndex = storeData.copyReducer.carrierKey[carrier.toLocaleUpperCase()];
      copyData = storeData.copyReducer.airlines[copyIndex];
    }

    return copyData;
  }

  getLatestCopyFromStore(store: Store<AppState>) {
    let state: AppState;
    store.pipe(take(1)).subscribe(s => state = s);
    return state;
  }

}
